import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from '../../Services/invoice.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { ClientLocation, ClientLocationDropDownValue } from 'src/app/clients-module/models/clientLocation';

@Component({
  selector: 'app-email-all-client-invoices',
  templateUrl: './email-all-client-invoices.component.html',
  styleUrls: ['./email-all-client-invoices.component.less']
})
export class EmailAllClientInvoicesComponent implements OnInit, OnDestroy {

  public fromDate: moment.Moment = moment().startOf('month').utc();
  public toDate: moment.Moment = moment().utc();
  public form: UntypedFormGroup;
  public saving : boolean = false;
  public submitted = false;
  locations: ClientLocationDropDownValue[] = [];
  constructor(
    public readonly modalService: NgbModal,
    private toasterService: ToastrService,
    private readonly invoiceService: InvoiceService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly propertyService: PropertyService
  ) {
    let defaultValue = new ClientLocationDropDownValue();
    defaultValue.clientLocationId = 0;
    defaultValue.locationName = 'All Available Locations';
    this.locations.push(defaultValue);
  }

  public ngOnInit(): void {
    this.createForm();
    this.propertyService.FetchAllPropertiesDropDownDataForUser().subscribe((scc: ClientLocationDropDownValue[]) => {
     scc.forEach(ddVal => {
       this.locations.push(ddVal);
     });
       this.form.controls['locationId'].setValue(0, {onlySelf: true});
    }, (err: any) => {
      this.toasterService.error("There was an error pulling locations for your user Id.", "Error fetching locations")
    });
  }

  public ngOnDestroy(): void {
    try {
      this.modalService.dismissAll();
    } catch (error) {

    }
  }

  public createForm(): void {
    this.form = this.formBuilder.group({
      demoMode: [true],
      toEmail: ['', [Validators.required, Validators.email]],
      fromDate: [this.fromDate.format('YYYY-MM-DD'), Validators.required],
      toDate: [this.toDate.format('YYYY-MM-DD'), Validators.required],
      locationId: [0],
    });

   
    this.form.controls.demoMode.valueChanges.subscribe((r: boolean) => {
      if (r) {
        this.form.controls.toEmail.enable();
      } else {
        this.form.controls.toEmail.disable();
      }
    });
  }

  public cancel(): void {
    this.modalService.dismissAll();
  }

  public save(): void {

    this.saving = true;
    //console.log(this.form.value)
    this.submitted = true;

    if (!this.form.valid) {
      return;
    }

    this.invoiceService.emailInvoices(this.form.value).subscribe(res => {
        this.toasterService.success('Seed for Invoices Sent!');
        this.modalService.dismissAll();
      },
      err => this.toasterService.error('Error sending seed for Invoices', '', {disableTimeOut: true, closeButton: true}),
      ()=>{
        this.saving = false;
      });
  }

  update(val: any) {

    console.log(val);

    if (val.property === 'fromDate') {
      this.fromDate = val.time;
    }

    if (val.property === 'toDate') {
      this.toDate = val.time;
    }
  }

}
